webpackJsonp([4],{

/***/ 983:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDayPicker = __webpack_require__(984);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	__webpack_require__(989);
	
	__webpack_require__(991);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(535);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactOnclickoutside = __webpack_require__(993);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _lodash = __webpack_require__(388);
	
	var DatePickInputer = (function (_Component) {
	  _inherits(DatePickInputer, _Component);
	
	  function DatePickInputer(props) {
	    _classCallCheck(this, DatePickInputer);
	
	    _get(Object.getPrototypeOf(DatePickInputer.prototype), 'constructor', this).call(this, props);
	    this.handleClickOutside = this.handleClickOutside.bind(this);
	    var _props = this.props;
	    var initialMonth = _props.initialMonth;
	    var formater = _props.formater;
	
	    formater = formater ? formater : 'YYYY/MM/DD';
	    var momentObject = typeof initialMonth === 'string' ? (0, _moment2['default'])(initialMonth, formater) : (0, _moment2['default'])(initialMonth);
	
	    if (this.props.allowEmpty) {
	      initialMonth = (0, _lodash.isEmpty)(initialMonth) === false ? momentObject.format(formater) : '';
	    } else {
	      initialMonth = momentObject.isValid() && momentObject.format(formater) || (0, _moment2['default'])().format(formater);
	    }
	
	    // 預設最小日期為1753/01/01
	    var minDateDefault = (0, _moment2['default'])('1753-01-01').startOf('day').toDate();
	    if (props.minDate && (0, _moment2['default'])(props.minDate).startOf('day').toDate() > (0, _moment2['default'])('1753-01-01').startOf('day').toDate()) {
	      minDateDefault = (0, _moment2['default'])(props.minDate).startOf('day').toDate();
	    }
	    // 預設最大日期為9999/12/31
	    var maxDateDefault = (0, _moment2['default'])('9999-12-31').startOf('day').toDate();
	    if (props.maxDate && (0, _moment2['default'])(props.maxDate).startOf('day').toDate() < (0, _moment2['default'])('9999-12-31').startOf('day').toDate()) {
	      maxDateDefault = (0, _moment2['default'])(props.maxDate).startOf('day').toDate();
	    }
	
	    this.state = {
	      isShowPicker: false,
	      value: initialMonth,
	      month: initialMonth === '' ? (0, _moment2['default'])().toDate() : (0, _moment2['default'])(initialMonth, formater).toDate(),
	      placeholder: props.placeholder || 'YYYY/MM/DD',
	      maxDate: maxDateDefault,
	      minDate: minDateDefault,
	      formater: formater
	    };
	  }
	
	  _createClass(DatePickInputer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var initialMonth = nextProps.initialMonth;
	      var formater = nextProps.formater;
	
	      formater = formater ? formater : 'YYYY/MM/DD';
	      var momentObject = typeof initialMonth === 'string' ? (0, _moment2['default'])(initialMonth, formater) : (0, _moment2['default'])(initialMonth);
	
	      if (nextProps.allowEmpty) {
	        initialMonth = (0, _lodash.isEmpty)(initialMonth) === false ? momentObject.format(formater) : '';
	      } else {
	        initialMonth = momentObject.isValid() && momentObject.format(formater) || (0, _moment2['default'])().format(formater);
	      }
	
	      // 預設最小日期為1753/01/01
	      var minDateDefault = (0, _moment2['default'])('1753-01-01').startOf('day').toDate();
	      if (nextProps.minDate && (0, _moment2['default'])(nextProps.minDate).startOf('day').toDate() > (0, _moment2['default'])('1752-12-31').startOf('day').toDate()) {
	        minDateDefault = (0, _moment2['default'])(nextProps.minDate).startOf('day').toDate();
	      }
	      // 預設最大日期為9999/12/31
	      var maxDateDefault = (0, _moment2['default'])('9999-12-31').startOf('day').toDate();
	      if (nextProps.maxDate && (0, _moment2['default'])(nextProps.maxDate).startOf('day').toDate() < (0, _moment2['default'])('10000-01-01').startOf('day').toDate()) {
	        maxDateDefault = (0, _moment2['default'])(nextProps.maxDate).startOf('day').toDate();
	      }
	      this.state = {
	        isShowPicker: false,
	        value: initialMonth,
	        month: initialMonth === '' ? (0, _moment2['default'])().toDate() : (0, _moment2['default'])(initialMonth, formater).toDate(),
	        placeholder: nextProps.placeholder || 'YYYY/MM/DD',
	        maxDate: maxDateDefault,
	        minDate: minDateDefault,
	        formater: formater
	      };
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.setState({
	        isShowPicker: false
	      });
	    }
	  }, {
	    key: 'handleTogglePicker',
	    value: function handleTogglePicker(event) {
	      event.preventDefault();
	      this.setState({
	        isShowPicker: !this.state.isShowPicker
	      });
	    }
	  }, {
	    key: 'handleDayClick',
	    value: function handleDayClick(e, day, modifiers) {
	      var _state = this.state;
	      var maxDate = _state.maxDate;
	      var minDate = _state.minDate;
	      var formater = _state.formater;
	
	      var date = (0, _moment2['default'])(day).startOf('day');
	      if (maxDate && date > maxDate) {
	        return;
	      }
	
	      if (minDate && date < minDate) {
	        return;
	      }
	
	      this.setState({
	        value: (0, _moment2['default'])(day).format(formater),
	        month: day,
	        isShowPicker: false
	      });
	
	      if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
	        this.props.handleDayClick(e, (0, _moment2['default'])(day).format(formater), modifiers);
	      }
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      var value = e.target.value;
	
	      this.setState({ value: value }, this.showCurrentDate);
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      if (e.keyCode === 13) {
	        // 按Enter時，寫入現在輸入的值，同Blur
	        this.handleInputBlur.call(this, e);
	      }
	    }
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(event) {
	      var _state2 = this.state;
	      var maxDate = _state2.maxDate;
	      var minDate = _state2.minDate;
	      var formater = _state2.formater;
	      var value = _state2.value;
	      var month = _state2.month;
	      var modifiers = _state2.modifiers;
	      var _props2 = this.props;
	      var allowEmpty = _props2.allowEmpty;
	      var toMinDate = _props2.toMinDate;
	
	      if (allowEmpty && (0, _lodash.isEmpty)(value)) {
	        if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
	          this.props.handleDayClick(event, null);
	        }
	        return;
	      }
	
	      var date = (0, _moment2['default'])(value, formater).startOf('day');
	
	      if (!date.isValid() || maxDate && date.toDate() > maxDate || minDate && date.toDate() < minDate) {
	        date = (0, _moment2['default'])(month);
	        if (toMinDate && !!minDate) date = (0, _moment2['default'])(minDate);
	        this.setState({
	          value: date.format(formater)
	        });
	      }
	
	      if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
	        this.props.handleDayClick(event, date.format(formater), modifiers);
	      }
	    }
	  }, {
	    key: 'showCurrentDate',
	    value: function showCurrentDate() {
	      this.refs.daypicker.showMonth(this.state.month);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state3 = this.state;
	      var value = _state3.value;
	      var isShowPicker = _state3.isShowPicker;
	      var month = _state3.month;
	      var placeholder = _state3.placeholder;
	      var maxDate = _state3.maxDate;
	      var minDate = _state3.minDate;
	      var modifiers = this.props.modifiers;
	      var _props3 = this.props;
	      var disabled = _props3.disabled;
	      var readOnly = _props3.readOnly;
	      var errorTipBorderStyle = _props3.errorTipBorderStyle;
	      var giveWidth = _props3.giveWidth;
	
	      modifiers = Object.assign({
	        selected: function selected(day) {
	          return _reactDayPicker.DateUtils.isSameDay(day, month);
	        },
	        disabled: function disabled(day) {
	          var date = (0, _moment2['default'])(day).startOf('day').toDate();
	          if (maxDate && date > maxDate) {
	            return true;
	          }
	          if (minDate && date < minDate) {
	            return true;
	          }
	
	          return false;
	        }
	      }, modifiers);
	
	      var originStyle = {
	        borderRadius: '5px 0px 0px 5px',
	        width: giveWidth
	      };
	      var Errortipborderstyle = Object.assign(originStyle, errorTipBorderStyle);
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: (0, _classnames2['default'])({
	            'datePickInputer__container': true,
	            'input-group': true
	          })
	        },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: (0, _classnames2['default'])({
	              'picker-container': true,
	              'active': isShowPicker
	            })
	          },
	          _react2['default'].createElement(_reactDayPicker2['default'], _extends({
	            ref: 'daypicker'
	          }, this.props, {
	            initialMonth: month,
	            modifiers: modifiers,
	            onDayClick: this.handleDayClick.bind(this)
	          }))
	        ),
	        _react2['default'].createElement('input', {
	          style: this.props.errorTipBorderStyle ? Errortipborderstyle : originStyle,
	          onBlur: this.handleInputBlur.bind(this),
	          type: 'text',
	          ref: 'input',
	          value: value,
	          className: 'form-control',
	          placeholder: placeholder,
	          onChange: this.handleInputChange.bind(this),
	          onFocus: this.showCurrentDate.bind(this),
	          disabled: disabled,
	          readOnly: readOnly,
	          onKeyDown: this.handleKeyDown.bind(this)
	        }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'input-group-btn' },
	          _react2['default'].createElement(
	            'button',
	            {
	              className: 'btn btn-default',
	              type: 'button',
	              disabled: disabled,
	              onClick: disabled || readOnly ? function (e) {
	                return e.preventDefault();
	              } : this.handleTogglePicker.bind(this)
	            },
	            _react2['default'].createElement('i', { className: 'fa fa-calendar' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DatePickInputer;
	})(_react.Component);
	
	DatePickInputer.propTypes = {
	  initialMonth: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  formater: _propTypes2['default'].string,
	  giveWidth: _propTypes2['default'].string,
	  placeholder: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].string]),
	  modifiers: _propTypes2['default'].object,
	  handleDayClick: _propTypes2['default'].func,
	  minDate: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  maxDate: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  errorTipBorderStyle: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  allowEmpty: _propTypes2['default'].bool,
	  toMinDate: _propTypes2['default'].bool
	};
	
	exports['default'] = (0, _reactOnclickoutside2['default'])(DatePickInputer);
	module.exports = exports['default'];

/***/ },

/***/ 984:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(985);
	module.exports.DateUtils = __webpack_require__(987);
	module.exports.LocaleUtils  = __webpack_require__(988);


/***/ },

/***/ 985:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Helpers = __webpack_require__(986);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	var _DateUtils = __webpack_require__(987);
	
	var _DateUtils2 = _interopRequireDefault(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(988);
	
	var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);
	
	var keys = {
	  LEFT: 37,
	  RIGHT: 39,
	  ENTER: 13,
	  SPACE: 32
	};
	
	var Caption = (function (_Component) {
	  _inherits(Caption, _Component);
	
	  function Caption() {
	    _classCallCheck(this, Caption);
	
	    _get(Object.getPrototypeOf(Caption.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Caption, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var date = _props.date;
	      var locale = _props.locale;
	      var localeUtils = _props.localeUtils;
	      var onClick = _props.onClick;
	
	      return _react2["default"].createElement(
	        "div",
	        { className: "DayPicker-Caption", onClick: onClick },
	        localeUtils.formatMonthTitle(date, locale)
	      );
	    }
	  }]);
	
	  return Caption;
	})(_react.Component);
	
	var DayPicker = (function (_Component2) {
	  _inherits(DayPicker, _Component2);
	
	  _createClass(DayPicker, null, [{
	    key: "propTypes",
	    value: {
	
	      className: _react.PropTypes.string,
	      style: _react.PropTypes.object,
	      tabIndex: _react.PropTypes.number,
	
	      initialMonth: _react.PropTypes.instanceOf(Date),
	      numberOfMonths: _react.PropTypes.number,
	
	      modifiers: _react.PropTypes.object,
	
	      locale: _react.PropTypes.string,
	      localeUtils: _react.PropTypes.shape({
	        formatMonthTitle: _react.PropTypes.func,
	        formatWeekdayShort: _react.PropTypes.func,
	        formatWeekdayLong: _react.PropTypes.func,
	        getFirstDayOfWeek: _react.PropTypes.func
	      }),
	
	      enableOutsideDays: _react.PropTypes.bool,
	      canChangeMonth: _react.PropTypes.bool,
	      fromMonth: _react.PropTypes.instanceOf(Date),
	      toMonth: _react.PropTypes.instanceOf(Date),
	
	      onDayClick: _react.PropTypes.func,
	      onDayTouchTap: _react.PropTypes.func,
	      onDayMouseEnter: _react.PropTypes.func,
	      onDayMouseLeave: _react.PropTypes.func,
	      onMonthChange: _react.PropTypes.func,
	      onCaptionClick: _react.PropTypes.func,
	
	      renderDay: _react.PropTypes.func,
	
	      captionElement: _react.PropTypes.element
	
	    },
	    enumerable: true
	  }, {
	    key: "defaultProps",
	    value: {
	      tabIndex: 0,
	      initialMonth: new Date(),
	      numberOfMonths: 1,
	      locale: "en",
	      localeUtils: _LocaleUtils2["default"],
	      enableOutsideDays: false,
	      canChangeMonth: true,
	      renderDay: function renderDay(day) {
	        return day.getDate();
	      },
	      captionElement: _react2["default"].createElement(Caption, null)
	    },
	    enumerable: true
	  }]);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    _get(Object.getPrototypeOf(DayPicker.prototype), "constructor", this).call(this, props);
	    this.state = {
	      currentMonth: _Helpers2["default"].startOfMonth(props.initialMonth)
	    };
	  }
	
	  _createClass(DayPicker, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.initialMonth !== nextProps.initialMonth) {
	        this.setState({
	          currentMonth: _Helpers2["default"].startOfMonth(nextProps.initialMonth)
	        });
	      }
	    }
	  }, {
	    key: "allowPreviousMonth",
	    value: function allowPreviousMonth() {
	      var fromMonth = this.props.fromMonth;
	
	      if (!fromMonth) {
	        return true;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      return _Helpers2["default"].getMonthsDiff(currentMonth, fromMonth) < 0;
	    }
	  }, {
	    key: "allowNextMonth",
	    value: function allowNextMonth() {
	      var _props2 = this.props;
	      var toMonth = _props2.toMonth;
	      var numberOfMonths = _props2.numberOfMonths;
	
	      if (!toMonth) {
	        return true;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      return _Helpers2["default"].getMonthsDiff(currentMonth, toMonth) >= numberOfMonths;
	    }
	  }, {
	    key: "allowMonth",
	    value: function allowMonth(d) {
	      var _props3 = this.props;
	      var fromMonth = _props3.fromMonth;
	      var toMonth = _props3.toMonth;
	
	      if (fromMonth && _Helpers2["default"].getMonthsDiff(fromMonth, d) < 0 || toMonth && _Helpers2["default"].getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "showMonth",
	    value: function showMonth(d) {
	      if (!this.allowMonth(d)) {
	        return;
	      }
	      this.setState({
	        currentMonth: _Helpers2["default"].startOfMonth(d)
	      });
	    }
	  }, {
	    key: "showNextMonth",
	    value: function showNextMonth(callback) {
	      var _this = this;
	
	      if (!this.allowNextMonth()) {
	        return;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      var nextMonth = _DateUtils2["default"].addMonths(currentMonth, 1);
	      this.setState({
	        currentMonth: nextMonth
	      }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this.props.onMonthChange) {
	          _this.props.onMonthChange(_this.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: "showPreviousMonth",
	    value: function showPreviousMonth(callback) {
	      var _this2 = this;
	
	      if (!this.allowPreviousMonth()) {
	        return;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      var prevMonth = _DateUtils2["default"].addMonths(currentMonth, -1);
	      this.setState({
	        currentMonth: prevMonth
	      }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this2.props.onMonthChange) {
	          _this2.props.onMonthChange(_this2.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: "focusPreviousDay",
	    value: function focusPreviousDay(dayNode) {
	      var body = dayNode.parentNode.parentNode.parentNode.parentNode;
	      var dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	      var nodeIndex = undefined;
	      for (var i = 0; i < dayNodes.length; i++) {
	        if (dayNodes[i] === dayNode) {
	          nodeIndex = i;
	          break;
	        }
	      }
	      if (nodeIndex === 0) {
	        var currentMonth = this.state.currentMonth;
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var prevMonth = _DateUtils2["default"].addMonths(currentMonth, -numberOfMonths);
	        this.setState({
	          currentMonth: prevMonth
	        }, function () {
	          dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	          dayNodes[dayNodes.length - 1].focus();
	        });
	      } else {
	        dayNodes[nodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: "focusNextDay",
	    value: function focusNextDay(dayNode) {
	      var body = dayNode.parentNode.parentNode.parentNode.parentNode;
	      var dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	      var nodeIndex = undefined;
	      for (var i = 0; i < dayNodes.length; i++) {
	        if (dayNodes[i] === dayNode) {
	          nodeIndex = i;
	          break;
	        }
	      }
	
	      if (nodeIndex === dayNodes.length - 1) {
	        var currentMonth = this.state.currentMonth;
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var nextMonth = _DateUtils2["default"].addMonths(currentMonth, numberOfMonths);
	        this.setState({
	          currentMonth: nextMonth
	        }, function () {
	          dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	          dayNodes[0].focus();
	        });
	      } else {
	        dayNodes[nodeIndex + 1].focus();
	      }
	    }
	
	    // Event handlers
	
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(e) {
	      switch (e.keyCode) {
	        case keys.LEFT:
	          this.showPreviousMonth();
	          break;
	        case keys.RIGHT:
	          this.showNextMonth();
	          break;
	      }
	    }
	  }, {
	    key: "handleDayKeyDown",
	    value: function handleDayKeyDown(e, day, modifiers) {
	      e.persist();
	      switch (e.keyCode) {
	        case keys.LEFT:
	          e.preventDefault();
	          e.stopPropagation();
	          this.focusPreviousDay(e.target);
	          break;
	        case keys.RIGHT:
	          e.preventDefault();
	          e.stopPropagation();
	          this.focusNextDay(e.target);
	          break;
	        case keys.ENTER:
	        case keys.SPACE:
	          e.preventDefault();
	          e.stopPropagation();
	          if (this.props.onDayClick) {
	            this.handleDayClick(e, day, modifiers);
	          }
	          if (this.props.onDayTouchTap) {
	            this.handleDayTouchTap(e, day, modifiers);
	          }
	          break;
	      }
	    }
	  }, {
	    key: "handleNextMonthClick",
	    value: function handleNextMonthClick() {
	      this.showNextMonth();
	    }
	  }, {
	    key: "handlePrevMonthClick",
	    value: function handlePrevMonthClick() {
	      this.showPreviousMonth();
	    }
	  }, {
	    key: "handleCaptionClick",
	    value: function handleCaptionClick(e, currentMonth) {
	      e.persist();
	      this.props.onCaptionClick(e, currentMonth);
	    }
	  }, {
	    key: "handleDayTouchTap",
	    value: function handleDayTouchTap(e, day, modifiers) {
	      e.persist();
	      if (modifiers.indexOf("outside") > -1) {
	        this.handleOutsideDayPress(day);
	      }
	      this.props.onDayTouchTap(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayClick",
	    value: function handleDayClick(e, day, modifiers) {
	      e.persist();
	      if (modifiers.indexOf("outside") > -1) {
	        this.handleOutsideDayPress(day);
	      }
	
	      this.props.onDayClick(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayMouseEnter",
	    value: function handleDayMouseEnter(e, day, modifiers) {
	      e.persist();
	      this.props.onDayMouseEnter(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayMouseLeave",
	    value: function handleDayMouseLeave(e, day, modifiers) {
	      e.persist();
	      this.props.onDayMouseLeave(e, day, modifiers);
	    }
	  }, {
	    key: "handleOutsideDayPress",
	    value: function handleOutsideDayPress(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	
	      var diffInMonths = _Helpers2["default"].getMonthsDiff(currentMonth, day);
	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: "renderNavBar",
	    value: function renderNavBar() {
	      var baseClass = "DayPicker-NavButton DayPicker-NavButton";
	      return _react2["default"].createElement(
	        "div",
	        { className: "DayPicker-NavBar" },
	        this.allowPreviousMonth() && _react2["default"].createElement("span", {
	          key: "prev",
	          className: baseClass + "--prev",
	          onClick: this.handlePrevMonthClick.bind(this) }),
	        this.allowNextMonth() && _react2["default"].createElement("span", {
	          key: "next",
	          className: baseClass + "--next",
	          onClick: this.handleNextMonthClick.bind(this) })
	      );
	    }
	  }, {
	    key: "renderMonth",
	    value: function renderMonth(date, i) {
	      var _this3 = this;
	
	      var _props4 = this.props;
	      var locale = _props4.locale;
	      var localeUtils = _props4.localeUtils;
	      var onCaptionClick = _props4.onCaptionClick;
	      var captionElement = _props4.captionElement;
	
	      var caption = _react2["default"].cloneElement(captionElement, {
	        date: date, localeUtils: localeUtils, locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return _this3.handleCaptionClick(e, date);
	        } : null
	      });
	
	      return _react2["default"].createElement(
	        "div",
	        {
	          className: "DayPicker-Month",
	          key: i },
	        caption,
	        _react2["default"].createElement(
	          "div",
	          { className: "DayPicker-Weekdays" },
	          _react2["default"].createElement(
	            "div",
	            { className: "DayPicker-WeekdaysRow" },
	            this.renderWeekDays()
	          )
	        ),
	        _react2["default"].createElement(
	          "div",
	          { className: "DayPicker-Body" },
	          this.renderWeeksInMonth(date)
	        )
	      );
	    }
	  }, {
	    key: "renderWeekDays",
	    value: function renderWeekDays() {
	      var _props5 = this.props;
	      var locale = _props5.locale;
	      var localeUtils = _props5.localeUtils;
	
	      var days = [];
	      for (var i = 0; i < 7; i++) {
	        days.push(_react2["default"].createElement(
	          "div",
	          { key: i, className: "DayPicker-Weekday" },
	          _react2["default"].createElement(
	            "abbr",
	            { title: localeUtils.formatWeekdayLong(i, locale) },
	            localeUtils.formatWeekdayShort(i, locale)
	          )
	        ));
	      }
	      return days;
	    }
	  }, {
	    key: "renderWeeksInMonth",
	    value: function renderWeeksInMonth(month) {
	      var _this4 = this;
	
	      var _props6 = this.props;
	      var locale = _props6.locale;
	      var localeUtils = _props6.localeUtils;
	
	      var firstDayOfWeek = localeUtils.getFirstDayOfWeek(locale);
	      return _Helpers2["default"].getWeekArray(month, firstDayOfWeek).map(function (week, i) {
	        return _react2["default"].createElement(
	          "div",
	          { key: i, className: "DayPicker-Week", role: "row" },
	          week.map(function (day) {
	            return _this4.renderDay(month, day);
	          })
	        );
	      });
	    }
	  }, {
	    key: "renderDay",
	    value: function renderDay(month, day) {
	      var _this5 = this;
	
	      var renderDay = this.props.renderDay;
	      var _props7 = this.props;
	      var enableOutsideDays = _props7.enableOutsideDays;
	      var modifierFunctions = _props7.modifiers;
	
	      var className = "DayPicker-Day";
	      var modifiers = [];
	      var key = "" + day.getFullYear() + day.getMonth() + day.getDate();
	
	      var isToday = _DateUtils2["default"].isSameDay(day, new Date());
	      if (isToday) {
	        modifiers.push("today");
	      }
	
	      var isOutside = day.getMonth() !== month.getMonth();
	      if (isOutside) {
	        modifiers.push("outside");
	      }
	
	      if (modifierFunctions) {
	        var customModifiers = _Helpers2["default"].getModifiersForDay(day, modifierFunctions);
	        modifiers = [].concat(_toConsumableArray(modifiers), _toConsumableArray(customModifiers));
	      }
	
	      className += modifiers.map(function (modifier) {
	        return " " + className + "--" + modifier;
	      }).join("");
	
	      if (isOutside && !enableOutsideDays) {
	        return _react2["default"].createElement("div", { key: "outside-" + key, className: className });
	      }
	
	      var _props8 = this.props;
	      var onDayMouseEnter = _props8.onDayMouseEnter;
	      var onDayMouseLeave = _props8.onDayMouseLeave;
	      var onDayTouchTap = _props8.onDayTouchTap;
	      var onDayClick = _props8.onDayClick;
	
	      var tabIndex = null;
	      if ((onDayTouchTap || onDayClick) && !isOutside) {
	        tabIndex = -1;
	        // Focus on the first day of the month
	        if (day.getDate() === 1) {
	          tabIndex = this.props.tabIndex;
	        }
	      }
	      return _react2["default"].createElement(
	        "div",
	        { key: key, className: className,
	          tabIndex: tabIndex,
	          role: "gridcell",
	          onKeyDown: function (e) {
	            return _this5.handleDayKeyDown(e, day, modifiers);
	          },
	          onMouseEnter: onDayMouseEnter ? function (e) {
	            return _this5.handleDayMouseEnter(e, day, modifiers);
	          } : null,
	          onMouseLeave: onDayMouseLeave ? function (e) {
	            return _this5.handleDayMouseLeave(e, day, modifiers);
	          } : null,
	          onClick: onDayClick ? function (e) {
	            return _this5.handleDayClick(e, day, modifiers);
	          } : null,
	          onTouchTap: onDayTouchTap ? function (e) {
	            return _this5.handleDayTouchTap(e, day, modifiers);
	          } : null
	        },
	        renderDay(day)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props9 = this.props;
	      var numberOfMonths = _props9.numberOfMonths;
	      var locale = _props9.locale;
	      var style = _props9.style;
	      var tabIndex = _props9.tabIndex;
	      var canChangeMonth = _props9.canChangeMonth;
	      var currentMonth = this.state.currentMonth;
	
	      var className = "DayPicker DayPicker--" + locale;
	
	      if (!this.props.onDayClick && !this.props.onDayTouchTap) {
	        className = className + " DayPicker--interactionDisabled";
	      }
	      if (this.props.className) {
	        className = className + " " + this.props.className;
	      }
	
	      var months = [];
	      var month = undefined;
	      for (var i = 0; i < numberOfMonths; i++) {
	        month = _DateUtils2["default"].addMonths(currentMonth, i);
	        months.push(this.renderMonth(month, i));
	      }
	
	      return _react2["default"].createElement(
	        "div",
	        { className: className,
	          style: style,
	          role: "widget",
	          tabIndex: canChangeMonth && tabIndex,
	          onKeyDown: canChangeMonth && this.handleKeyDown.bind(this) },
	        canChangeMonth && this.renderNavBar(),
	        months
	      );
	    }
	  }]);
	
	  return DayPicker;
	})(_react.Component);
	
	exports["default"] = DayPicker;
	module.exports = exports["default"];
	//# sourceMappingURL=DayPicker.js.map

/***/ },

/***/ 986:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _DateUtils = __webpack_require__(987);
	
	var _DateUtils2 = _interopRequireDefault(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(988);
	
	var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);
	
	exports["default"] = {
	
	  startOfMonth: function startOfMonth(d) {
	    var newDate = _DateUtils2["default"].clone(d);
	    newDate.setDate(1);
	    newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
	    return newDate;
	  },
	
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	  },
	
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	
	    return resultDate.getDate();
	  },
	
	  getWeekArray: function getWeekArray(d) {
	    var firstDayOfWeek = arguments.length <= 1 || arguments[1] === undefined ? _LocaleUtils2["default"].getFirstDayOfWeek() : arguments[1];
	
	    var daysInMonth = this.getDaysInMonth(d);
	    var dayArray = [];
	
	    var week = [];
	    var weekArray = [];
	
	    for (var i = 1; i <= daysInMonth; i++) {
	      dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	    }
	
	    dayArray.forEach(function (day) {
	      if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	        weekArray.push(week);
	        week = [];
	      }
	      week.push(day);
	      if (dayArray.indexOf(day) === dayArray.length - 1) {
	        weekArray.push(week);
	      }
	    });
	
	    // unshift days to start the first week
	    var firstWeek = weekArray[0];
	    for (var i = 7 - firstWeek.length; i > 0; i--) {
	      var outsideDate = _DateUtils2["default"].clone(firstWeek[0]);
	      outsideDate.setDate(firstWeek[0].getDate() - 1);
	      firstWeek.unshift(outsideDate);
	    }
	
	    // push days until the end of the last week
	    var lastWeek = weekArray[weekArray.length - 1];
	    for (var i = lastWeek.length; i < 7; i++) {
	      var outsideDate = _DateUtils2["default"].clone(lastWeek[lastWeek.length - 1]);
	      outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
	      lastWeek.push(outsideDate);
	    }
	
	    return weekArray;
	  },
	
	  getModifiersForDay: function getModifiersForDay(d, modifierFunctions) {
	    var modifiers = [];
	    if (modifierFunctions) {
	      for (var modifier in modifierFunctions) {
	        var func = modifierFunctions[modifier];
	        if (func(d)) {
	          modifiers.push(modifier);
	        }
	      }
	    }
	    return modifiers;
	  },
	
	  getMonthsDiff: function getMonthsDiff(d1, d2) {
	    return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	  }
	
	};
	module.exports = exports["default"];
	//# sourceMappingURL=Helpers.js.map

/***/ },

/***/ 987:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DateUtils = {
	
	  /**
	   * Return `d` as a new date with `n` months added.
	   * @param {[type]} d
	   * @param {[type]} n
	   */
	  addMonths: function addMonths(d, n) {
	    var newDate = DateUtils.clone(d);
	    newDate.setMonth(d.getMonth() + n);
	    return newDate;
	  },
	
	  /**
	   * Clone a date object.
	   *
	   * @param  {Date} d The date to clone
	   * @return {Date} The cloned date
	   */
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	
	  /**
	   * Return `true` if two dates are the same day, ignoring the time.
	   *
	   * @param  {Date}  d1
	   * @param  {Date}  d2
	   * @return {Boolean}
	   */
	  isSameDay: function isSameDay(d1, d2) {
	    if (!d1 || !d2) {
	      return false;
	    }
	    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	  },
	
	  /**
	   * Return `true` if a day is in the past, e.g. yesterday or any day
	   * before yesterday.
	   *
	   * @param  {Date}  d
	   * @return {Boolean}
	   */
	  isPastDay: function isPastDay(d) {
	    var today = new Date();
	    today.setHours(0, 0, 0, 0);
	    return d < today;
	  },
	
	  /**
	   * Return `true` if day `d` is between days `d1` and `d2`,
	   * without including them.
	   *
	   * @param  {Date}  d
	   * @param  {Date}  d1
	   * @param  {Date}  d2
	   * @return {Boolean}
	   */
	  isDayBetween: function isDayBetween(d, d1, d2) {
	    d = DateUtils.clone(d);
	    d1 = DateUtils.clone(d1);
	    d2 = DateUtils.clone(d2);
	
	    d.setHours(0, 0, 0, 0);
	    d1.setHours(0, 0, 0, 0);
	    d2.setHours(0, 0, 0, 0);
	    return d1 < d && d < d2 || d2 < d && d < d1;
	  },
	
	  /**
	   * Add a day to a range and return a new range. A range is an object with
	   * `from` and `to` days.
	   *
	   * @param {Date} day
	   * @param {Object} range
	   * @return {Object} Returns a new range object
	   */
	  addDayToRange: function addDayToRange(day) {
	    var range = arguments.length <= 1 || arguments[1] === undefined ? { from: null, to: null } : arguments[1];
	    var from = range.from;
	    var to = range.to;
	
	    if (!from) {
	      from = day;
	    } else if (from && to && DateUtils.isSameDay(from, to) && DateUtils.isSameDay(day, from)) {
	      from = null;
	      to = null;
	    } else if (to && day < from) {
	      from = day;
	    } else if (to && DateUtils.isSameDay(day, to)) {
	      from = day;
	      to = day;
	    } else {
	      to = day;
	      if (to < from) {
	        to = from;
	        from = day;
	      }
	    }
	
	    return { from: from, to: to };
	  },
	
	  /**
	   * Return `true` if a day is included in a range of days.
	   *
	   * @param  {Date}  day
	   * @param  {Object}  range
	   * @return {Boolean}
	   */
	  isDayInRange: function isDayInRange(day, range) {
	    var from = range.from;
	    var to = range.to;
	
	    return from && DateUtils.isSameDay(day, from) || to && DateUtils.isSameDay(day, to) || from && to && DateUtils.isDayBetween(day, from, to);
	  }
	
	};
	
	exports["default"] = DateUtils;
	module.exports = exports["default"];
	//# sourceMappingURL=DateUtils.js.map

/***/ },

/***/ 988:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WEEKDAYS_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	var WEEKDAYS_SHORT = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
	
	var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	exports["default"] = {
	
	  formatMonthTitle: function formatMonthTitle(d) {
	    return MONTHS[d.getMonth()] + " " + d.getFullYear();
	  },
	
	  formatWeekdayShort: function formatWeekdayShort(i) {
	    return WEEKDAYS_SHORT[i];
	  },
	
	  formatWeekdayLong: function formatWeekdayLong(i) {
	    return WEEKDAYS_LONG[i];
	  },
	
	  getFirstDayOfWeek: function getFirstDayOfWeek() {
	    return 0;
	  },
	
	  getMonths: function getMonths() {
	    return MONTHS;
	  }
	
	};
	module.exports = exports["default"];
	//# sourceMappingURL=LocaleUtils.js.map

/***/ },

/***/ 989:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(990);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 990:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".DayPicker{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;position:relative;padding:1rem 0}.DayPicker,.DayPicker-Month{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Month{display:table;border-collapse:collapse;border-spacing:0;margin:0 1rem}.DayPicker-NavBar{position:absolute;left:0;right:0;padding:0 .5rem}.DayPicker-NavButton{position:absolute;width:1.5rem;height:1.5rem;background-repeat:no-repeat;background-position:center;background-size:contain;cursor:pointer}.DayPicker-NavButton--prev{left:1rem;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\")}.DayPicker-NavButton--next{right:1rem;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\")}.DayPicker-Caption{display:table-caption;height:1.5rem;text-align:center}.DayPicker-Weekdays{display:table-header-group}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5rem;font-size:.875em;text-align:center;color:#8b9898}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{display:table-cell;padding:.5rem;border:1px solid #eaecec;text-align:center;cursor:pointer;vertical-align:middle}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Day--today{color:#d0021b;font-weight:500}.DayPicker-Day--disabled{background-color:#eff1f1}.DayPicker-Day--disabled,.DayPicker-Day--outside{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{color:#dce0e0;background-color:#f7f8f8}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){color:#fff;background-color:#4a90e2}.DayPicker--ar{direction:rtl}", ""]);
	
	// exports


/***/ },

/***/ 991:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(992);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./DatePickInputer.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./DatePickInputer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 992:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".picker-container{position:absolute;top:33px;right:0;overflow:hidden;display:none}.picker-container .DayPicker{background-color:#fff;z-index:4;border-radius:0 0 5px 5px;box-shadow:0 5px 6px rgba(0,0,0,.2);border:1px solid #ccc;transform:translateY(-100%);transition:all .2s ease-in}.picker-container.active{display:block;overflow:visible}.picker-container.active .DayPicker{transition:all .2s ease-in;transform:translateY(0);z-index:5}.DayPicker-Day--selected{background-color:#4a90e2;color:#fff}.datePickInputer__container>.form-control{color:#333}", ""]);
	
	// exports


/***/ },

/***/ 996:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(997);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(1009);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1010);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(1011);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(1008);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(1006);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(1005);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(1000);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(1001);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(1002);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },

/***/ 997:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(998);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(999);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(192);
	
	var _defaultArrowRenderer = __webpack_require__(1000);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(1001);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(1002);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(1005);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(1006);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(1008);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },

/***/ 998:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },

/***/ 999:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },

/***/ 1000:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },

/***/ 1001:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },

/***/ 1002:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(1003);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1004);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },

/***/ 1003:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },

/***/ 1004:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },

/***/ 1005:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(999);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },

/***/ 1006:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(999);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1007);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },

/***/ 1007:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },

/***/ 1008:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(999);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },

/***/ 1009:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(997);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(1003);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },

/***/ 1010:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(1009);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(1011);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(997);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },

/***/ 1011:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(1002);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(1005);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(997);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },

/***/ 1304:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Loading;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1305);
	
	var propTypes = {
	  children: _propTypes2['default'].object,
	  small: _propTypes2['default'].bool,
	  loadingContainerStyle: _propTypes2['default'].object,
	  btn: _propTypes2['default'].bool,
	  loadingPositionStyle: _propTypes2['default'].object
	};
	
	var defaultProps = {
	  small: false,
	  btn: false
	};
	
	function Loading(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: (0, _classnames2['default'])('loading__container', { 'loading__container--btn': props.btn }), style: props.loadingContainerStyle },
	    _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])('loading', { 'loading--btn': props.btn, small: props.small }) },
	      _react2['default'].createElement(
	        'ul',
	        { style: props.loadingPositionStyle },
	        _react2['default'].createElement('li', { className: (0, _classnames2['default'])({ 'loading__cycle': true, 'loading__cycle--small': props.small }) }),
	        _react2['default'].createElement('li', { className: (0, _classnames2['default'])({ 'loading__cycle': true, 'loading__cycle--small': props.small }) }),
	        _react2['default'].createElement('li', { className: (0, _classnames2['default'])({ 'loading__cycle': true, 'loading__cycle--small': props.small }) })
	      )
	    ),
	    props.children
	  );
	}
	
	Loading.propTypes = propTypes;
	Loading.defualtTypes = defaultProps;
	module.exports = exports['default'];

/***/ },

/***/ 1305:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1306);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1306:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".loading__container{position:relative;width:100%;height:100%;padding:30px;text-align:center}.loading__container--btn{padding:0}.loading{margin-bottom:25px;position:relative}.loading--btn{margin:0;position:static}.loading ul{list-style:none;margin:0;padding:0;position:absolute;top:50%;left:50%;transform:translate(-10px, -10px);font-size:0}.loading.small ul{transform:translate(-3.5px, -3.5px)}.loading__cycle{height:0;position:absolute;top:50%;left:0;width:0;margin:0;height:20px;width:20px;border-radius:100%;transform:transformZ(0);animation:LOADING 2s infinite}.loading__cycle--small{width:7px;height:7px}.loading__cycle:nth-child(1n){left:-20px;animation-delay:0s}.loading__cycle:nth-child(2n){left:0;animation-delay:.2s}.loading__cycle:nth-child(3n){left:20px;animation-delay:.4s}.loading__cycle--small:nth-child(1n){left:-10px}.loading__cycle--small:nth-child(2n){left:0}.loading__cycle--small:nth-child(3n){left:10px}.loading__cycle--reversed li{animation:LOADINGREV 2s infinite}.loading__cycle--reversed li:nth-child(1n){animation-delay:0s}.loading__cycle--reversed li:nth-child(2n){animation-delay:.2s}.loading__cycle--reversed li:nth-child(3n){animation-delay:.4s}@keyframes LOADING{0%{transform:scale(0.5);background:#999}50%{transform:scale(1);background:#fff}to{transform:scale(0.5);background:#999}}@keyframes LOADINGREV{0%{transform:scale(0.5);background:#fff}50%{transform:scale(1);background:#999}to{transform:scale(0.5);background:#fff}}", ""]);
	
	// exports


/***/ },

/***/ 1404:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsChangeRecord = __webpack_require__(1405);
	
	var _componentsChangeRecord2 = _interopRequireDefault(_componentsChangeRecord);
	
	var _reactRedux = __webpack_require__(642);
	
	var _reducersEffectiveDataReducer = __webpack_require__(501);
	
	var _reducersChangeRecordsReducer = __webpack_require__(502);
	
	var _componentsInfoView = __webpack_require__(1408);
	
	var _componentsInfoView2 = _interopRequireDefault(_componentsInfoView);
	
	var _componentsViewDataItem = __webpack_require__(1409);
	
	var _componentsViewDataItem2 = _interopRequireDefault(_componentsViewDataItem);
	
	var _componentsNewRecordApplyForm = __webpack_require__(1413);
	
	var _componentsNewRecordApplyForm2 = _interopRequireDefault(_componentsNewRecordApplyForm);
	
	var _reduxForm = __webpack_require__(640);
	
	var _humps = __webpack_require__(385);
	
	var _lodash = __webpack_require__(388);
	
	var _reactIntl = __webpack_require__(818);
	
	var _componentsLoading = __webpack_require__(1304);
	
	var _componentsLoading2 = _interopRequireDefault(_componentsLoading);
	
	var BasicInfo = (function (_Component) {
	  _inherits(BasicInfo, _Component);
	
	  function BasicInfo() {
	    _classCallCheck(this, BasicInfo);
	
	    _get(Object.getPrototypeOf(BasicInfo.prototype), 'constructor', this).call(this);
	    this.state = {
	      showForm: false,
	      isInitialized: false
	    };
	    this.onClickApplyButton = this.onClickApplyButton.bind(this);
	    this.onCloseFormClick = this.onCloseFormClick.bind(this);
	    this.onFormSubmit = this.onFormSubmit.bind(this);
	  }
	
	  _createClass(BasicInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      Promise.all([this.props.fetchEffectiveData(), this.props.fetchChangeRecords()]).then(function () {
	        return _this.setState({ isInitialized: true });
	      }, function () {
	        return _this.setState({ isInitialized: true });
	      });
	    }
	  }, {
	    key: 'onClickApplyButton',
	    value: function onClickApplyButton() {
	      this.props.initialize(_componentsNewRecordApplyForm.formName, this.props.effectiveData.data, _componentsNewRecordApplyForm.fields);
	      this.setState({
	        showForm: true
	      });
	    }
	  }, {
	    key: 'onCloseFormClick',
	    value: function onCloseFormClick(event) {
	      event.preventDefault();
	      this.setState({
	        showForm: false
	      });
	    }
	  }, {
	    key: 'onFormSubmit',
	    value: function onFormSubmit(value) {
	      var _this2 = this;
	
	      var formData = new FormData();
	      formData.append('attachFile', value.attachFile);
	      delete value.attachFile;
	      value.action = 'PUT';
	      formData.append('Data', JSON.stringify((0, _humps.pascalizeKeys)(value)));
	      return this.props.addChangeRecord(formData).then(function () {
	        _this2.props.fetchChangeRecords();
	        _this2.setState({
	          showForm: false
	        });
	        return Promise.resolve();
	      }, function (json) {
	        return Promise.reject({ _error: json.message });
	      });
	    }
	  }, {
	    key: 'renderViewItems',
	    value: function renderViewItems() {
	      var _props = this.props;
	      var effectiveData = _props.effectiveData;
	      var fieldSettings = _props.fieldSettings;
	      var changeRecords = _props.changeRecords;
	
	      if (effectiveData.data === null || fieldSettings.data === null || !changeRecords.isLoaded) {
	        return '';
	      }
	      var allowEdit = (0, _lodash.find)(changeRecords.data, function (data) {
	        return data.currentStatus === '40' || data.currentStatus === '10';
	      }) === undefined;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'tab-body clearfix' },
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn action', onClick: this.onClickApplyButton, disabled: !allowEdit },
	          _react2['default'].createElement('i', { className: 'glyphicon glyphicon-pencil' })
	        ),
	        _react2['default'].createElement(_componentsInfoView2['default'], { basicInfo: effectiveData.data, fieldSettings: fieldSettings.data })
	      );
	    }
	  }, {
	    key: 'renderChangeRecords',
	    value: function renderChangeRecords() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var changeRecords = _props2.changeRecords;
	      var fieldSettings = _props2.fieldSettings;
	
	      if (!changeRecords.data || !fieldSettings.data) {
	        return '';
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'change-record-container' },
	        changeRecords.data.map(function (record) {
	          var recordId = record.id;
	          return _react2['default'].createElement(
	            _componentsChangeRecord2['default'],
	            {
	              date: record.createOn,
	              status: record.currentStatus,
	              rejectReason: record.backReasons,
	              key: record.id,
	              onDelete: function (event) {
	                event.preventDefault();
	                _this3.props.removeChangeRecord(recordId);
	              }
	            },
	            _react2['default'].createElement(
	              _componentsInfoView2['default'],
	              { basicInfo: record, fieldSettings: fieldSettings.data },
	              _react2['default'].createElement('hr', null),
	              _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_ModifyReason', defaultMessage: '修改原因' })], text: record.reasons }),
	              _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_SupportingDocuments', defaultMessage: '證明文件' })], text: record.displayFilename })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isInitialized = this.state.isInitialized;
	      var _props3 = this.props;
	      var params = _props3.params;
	      var fieldSettings = _props3.fieldSettings;
	
	      if (!isInitialized) {
	        return _react2['default'].createElement(_componentsLoading2['default'], { small: true });
	      }
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.state.showForm && params.isLoaded && fieldSettings.isLoaded && _react2['default'].createElement(_componentsNewRecordApplyForm2['default'], {
	          onSubmit: this.onFormSubmit,
	          genders: params.data.Sex,
	          arms: params.data.Arms,
	          nationality: params.data.Nationality,
	          militaryService: params.data.MilitaryService,
	          maritalStatusOptions: params.data.MaritalStatus,
	          iDTypes: params.data.IDType,
	          fieldSettings: fieldSettings.data,
	          onClose: this.onCloseFormClick
	        }),
	        this.renderViewItems(),
	        this.renderChangeRecords()
	      );
	    }
	  }]);
	
	  return BasicInfo;
	})(_react.Component);
	
	BasicInfo.propTypes = {
	  fetchEffectiveData: _propTypes2['default'].func.isRequired,
	  effectiveData: _propTypes2['default'].object.isRequired,
	  fetchChangeRecords: _propTypes2['default'].func.isRequired,
	  changeRecords: _propTypes2['default'].object.isRequired,
	  fieldSettings: _propTypes2['default'].object.isRequired,
	  params: _propTypes2['default'].object.isRequired,
	  initialize: _propTypes2['default'].func.isRequired,
	  addChangeRecord: _propTypes2['default'].func.isRequired,
	  removeChangeRecord: _propTypes2['default'].func.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    effectiveData: state.app.foundation.mydata.basicInfo.effectiveData,
	    changeRecords: state.app.foundation.mydata.basicInfo.changeRecords,
	    fieldSettings: state.app.foundation.mydata.fieldSettings,
	    params: state.app.foundation.mydata.params
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchEffectiveData: _reducersEffectiveDataReducer.fetchEffectiveData,
	  fetchChangeRecords: _reducersChangeRecordsReducer.fetchChangeRecords,
	  initialize: _reduxForm.initialize,
	  addChangeRecord: _reducersChangeRecordsReducer.addChangeRecord,
	  removeChangeRecord: _reducersChangeRecordsReducer.removeChangeRecord
	})(BasicInfo);
	module.exports = exports['default'];

/***/ },

/***/ 1405:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(535);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1406);
	
	var _reactIntl = __webpack_require__(818);
	
	var messages = (0, _reactIntl.defineMessages)({
	  add: {
	    id: 'SH_Add',
	    defaultMessage: '新增'
	  },
	  cancel: {
	    id: 'SH_Cancel02',
	    defaultMessage: '取消'
	  },
	  approval: {
	    id: 'SH_PendingForApproval',
	    defaultMessage: '審核中'
	  },
	  'return': {
	    id: 'SH_Rejected',
	    defaultMessage: '退回'
	  },
	  finish: {
	    id: 'FD_ReviewCompletedUpdate',
	    defaultMessage: '審核完成已更新'
	  },
	  edit: {
	    id: 'SH_Modify',
	    defaultMessage: '修改'
	  },
	  'delete': {
	    id: 'SH_Delete',
	    defaultMessage: '刪除'
	  }
	});
	
	var ChangeRecord = (function (_Component) {
	  _inherits(ChangeRecord, _Component);
	
	  function ChangeRecord(props) {
	    _classCallCheck(this, ChangeRecord);
	
	    _get(Object.getPrototypeOf(ChangeRecord.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      isOpened: false
	    };
	    this.toggleChangeRecord = this.toggleChangeRecord.bind(this);
	  }
	
	  _createClass(ChangeRecord, [{
	    key: 'getStatueString',
	    value: function getStatueString(status, rejectReason) {
	      switch (status) {
	        case '10':
	          return this.props.intl.formatMessage(messages.add);
	        case '30':
	          return this.props.intl.formatMessage(messages.cancel);
	        case '40':
	          return this.props.intl.formatMessage(messages.approval);
	        case '50':
	          return _react2['default'].createElement(
	            'span',
	            null,
	            this.props.intl.formatMessage(messages['return']),
	            _react2['default'].createElement('i', { className: 'fa fa-long-arrow-right' }),
	            ' ',
	            rejectReason
	          );
	        case '99':
	          return this.props.intl.formatMessage(messages.finish);
	        default:
	          return this.props.intl.formatMessage(messages.finish);
	      }
	    }
	  }, {
	    key: 'getAactionString',
	    value: function getAactionString(action) {
	      switch (action) {
	        case 'POST':
	          return this.props.intl.formatMessage(messages.add);
	        case 'PUT':
	          return this.props.intl.formatMessage(messages.edit);
	        case 'Delete':
	          return this.props.intl.formatMessage(messages['delete']);
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'toggleChangeRecord',
	    value: function toggleChangeRecord() {
	      this.setState({
	        'isOpened': !this.state.isOpened
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'change-record' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'change-record-info' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'change-record-date' },
	            this.props.date && (0, _moment2['default'])(this.props.date).format('YYYY/MM/DD'),
	            ' ',
	            this.props.title
	          ),
	          _react2['default'].createElement(
	            'span',
	            null,
	            this.getAactionString(this.props.action)
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: 'change-record-status' },
	            '( ',
	            _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'FD_ApplicationStatus', defaultMessage: '申請狀態' }),
	            ': ',
	            this.getStatueString(this.props.status, this.props.rejectReason),
	            ' )'
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: 'pull-right change-record-action-group' },
	            this.props.status === '10' && _react2['default'].createElement('i', { className: 'fa fa-trash', onClick: this.props.onDelete }),
	            _react2['default'].createElement('i', {
	              className: (0, _classnames2['default'])({
	                'fa': true,
	                'fa-chevron-circle-up': this.state.isOpened,
	                'fa-chevron-circle-down': !this.state.isOpened
	              }),
	              onClick: this.toggleChangeRecord
	            })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            className: (0, _classnames2['default'])({
	              'change-record-detail': true,
	              'open': this.state.isOpened
	            })
	          },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ChangeRecord;
	})(_react.Component);
	
	ChangeRecord.propTypes = {
	  children: _propTypes2['default'].object,
	  date: _propTypes2['default'].string,
	  title: _propTypes2['default'].string,
	  status: _propTypes2['default'].string,
	  rejectReason: _propTypes2['default'].string,
	  onDelete: _propTypes2['default'].func.isRequired,
	  action: _propTypes2['default'].string,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports['default'] = (0, _reactIntl.injectIntl)(ChangeRecord);
	module.exports = exports['default'];

/***/ },

/***/ 1406:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1407);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1407:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".change-record{margin-bottom:10px;overflow:hidden}.change-record-info{background:#f2dede;padding:10px;color:#a94442;z-index:1}.change-record-date{margin-right:5px}.change-record-action-group{color:#bdbdbd;font-size:18px}.change-record-action-group i{margin-right:5px;cursor:pointer}.change-record-action-group i:last-child{margin-right:0}.change-record-detail{display:none;padding:10px}.change-record-detail.open{display:block}", ""]);
	
	// exports


/***/ },

/***/ 1408:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsViewDataItem = __webpack_require__(1409);
	
	var _componentsViewDataItem2 = _interopRequireDefault(_componentsViewDataItem);
	
	var _reactIntl = __webpack_require__(818);
	
	var _containersAppScreensFoundationUtilsDateFormatView = __webpack_require__(1412);
	
	var _containersAppScreensFoundationUtilsDateFormatView2 = _interopRequireDefault(_containersAppScreensFoundationUtilsDateFormatView);
	
	var InfoView = (function (_Component) {
	  _inherits(InfoView, _Component);
	
	  function InfoView() {
	    _classCallCheck(this, InfoView);
	
	    _get(Object.getPrototypeOf(InfoView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(InfoView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var basicInfo = _props.basicInfo;
	      var fieldSettings = _props.fieldSettings;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_LastName', defaultMessage: '姓' })], text: basicInfo.lastName }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_FirstName', defaultMessage: '名' })], text: basicInfo.firstName }),
	        fieldSettings['0040'].isDisplay && _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_EnglishName', defaultMessage: '英文姓名' })], text: basicInfo.englishName }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_Nationality', defaultMessage: '國藉' })], text: basicInfo.nationText }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_Gender', defaultMessage: '性別' })], text: basicInfo.genderText }),
	        fieldSettings['0060'].isDisplay && _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceStatus', defaultMessage: '兵役狀態' })], text: basicInfo.armyStatusText }),
	        fieldSettings['0060'].isDisplay && basicInfo.armyStatus !== '2' && basicInfo.armyStatus !== '3' && _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceType', defaultMessage: '役別' })], text: basicInfo.armyTypeText }),
	        fieldSettings['0060'].isDisplay && basicInfo.armyStatus !== '2' && basicInfo.armyStatus !== '3' && _react2['default'].createElement(_componentsViewDataItem2['default'], {
	          label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServicePeriod', defaultMessage: '兵役期間' })],
	          text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'armyStart') + ' - ' + (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'armyEnd')
	        }),
	        fieldSettings['0060'].isDisplay && basicInfo.armyStatus === '2' && basicInfo.armyStatus === '3' && _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_WaivedReason', defaultMessage: '免役原因' })], text: basicInfo.exemptReason }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_IdentificationDocumentType', defaultMessage: '識別證件類型' })], text: basicInfo.iDTypeText }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_IdentificationDocumentNumber', defaultMessage: '識別證件號碼' })], text: basicInfo.iDNumber }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '' } })], text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'iDExpiryDate') }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocType', defaultMessage: '識別證件類型{0}', values: { 0: '2' } })], text: basicInfo.iDType2 }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocNumber', defaultMessage: '識別證件號碼{0}', values: { 0: '2' } })], text: basicInfo.iDNumber2 }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '2' } })], text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'iDExpiryDate2') }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocType', defaultMessage: '識別證件類型{0}', values: { 0: '3' } })], text: basicInfo.iDType3 }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocNumber', defaultMessage: '識別證件號碼{0}', values: { 0: '3' } })], text: basicInfo.iDNumber3 }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '3' } })], text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'iDExpiryDate3') }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_DateOfEntry', defaultMessage: '入境時間' })], text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'entryTime') }),
	        _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_DateOfBirth', defaultMessage: '生日' })], text: (0, _containersAppScreensFoundationUtilsDateFormatView2['default'])(basicInfo, 'birthday') }),
	        fieldSettings['0100'].isDisplay && _react2['default'].createElement(_componentsViewDataItem2['default'], { label: [_react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MaterialStatus', defaultMessage: '婚姻狀態' })], text: basicInfo.maritalStatusText }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return InfoView;
	})(_react.Component);
	
	exports['default'] = InfoView;
	
	InfoView.propTypes = {
	  basicInfo: _propTypes2['default'].object.isRequired,
	  children: _propTypes2['default'].array,
	  fieldSettings: _propTypes2['default'].object.isRequired
	};
	module.exports = exports['default'];

/***/ },

/***/ 1409:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1410);
	
	var ViewDataItem = (function (_Component) {
	  _inherits(ViewDataItem, _Component);
	
	  function ViewDataItem() {
	    _classCallCheck(this, ViewDataItem);
	
	    _get(Object.getPrototypeOf(ViewDataItem.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ViewDataItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'data-view-group row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-4' },
	          this.props.label,
	          ' :'
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-8' },
	          this.props.text
	        )
	      );
	    }
	  }]);
	
	  return ViewDataItem;
	})(_react.Component);
	
	exports['default'] = ViewDataItem;
	
	ViewDataItem.propTypes = {
	  label: _propTypes2['default'].array.isRequired,
	  text: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
	};
	module.exports = exports['default'];

/***/ },

/***/ 1410:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1411);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1411:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".data-view-group{margin-bottom:10px}.data-view-group div:first-child{text-align:right}", ""]);
	
	// exports


/***/ },

/***/ 1412:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = dateFormatView;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(535);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function dateFormatView(paramFormName, paramDateTime) {
	  var formatDateTime = '';
	  if (!paramFormName[paramDateTime] || paramFormName[paramDateTime].indexOf('0001-01-01') > -1) {
	    formatDateTime = '';
	  } else {
	    formatDateTime = (0, _moment2['default'])(paramFormName[paramDateTime]).format('YYYY/MM/DD');
	  }
	  return formatDateTime;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1413:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentsWindowBox = __webpack_require__(1414);
	
	var _componentsWindowBox2 = _interopRequireDefault(_componentsWindowBox);
	
	var _componentsFormItem = __webpack_require__(1417);
	
	var _componentsFormItem2 = _interopRequireDefault(_componentsFormItem);
	
	var _reduxForm = __webpack_require__(640);
	
	var _reactIntl = __webpack_require__(818);
	
	var _containersAppScreensFoundationUtilsVerify = __webpack_require__(1420);
	
	var messages = (0, _reactIntl.defineMessages)({
	  isRequired: {
	    id: 'SH_FieldRequired',
	    defaultMessage: '欄位為必填'
	  },
	  fileSizeLimit: {
	    id: 'SH_FileSizeLimit',
	    defaultMessage: '大小限制為 {0}'
	  },
	  emptyData: {
	    id: 'SH_OpenFileError01',
	    defaultMessage: '不可上傳空白檔案'
	  },
	  formatError: {
	    id: 'SH_NotSupportFormat',
	    defaultMessage: '格式錯誤'
	  }
	});
	
	var NewRecordApplyForm = (function (_Component) {
	  _inherits(NewRecordApplyForm, _Component);
	
	  function NewRecordApplyForm() {
	    _classCallCheck(this, NewRecordApplyForm);
	
	    _get(Object.getPrototypeOf(NewRecordApplyForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NewRecordApplyForm, [{
	    key: 'onAttachFileUpload',
	    value: function onAttachFileUpload(event) {
	      event.preventDefault();
	      if (!event.target.files || event.target.files.length === 0) {
	        return;
	      }
	      this.props.fields.attachFile.onChange(event.target.files[0]);
	    }
	  }, {
	    key: 'renderArmyStatusElem',
	    value: function renderArmyStatusElem() {
	      var _props = this.props;
	      var militaryService = _props.militaryService;
	      var armyStatus = _props.fields.armyStatus;
	
	      var armyFieldSetting = this.props.fieldSettings['0060'];
	
	      if (armyFieldSetting.isDisplay === false) {
	        return '';
	      }
	
	      return _react2['default'].createElement(_componentsFormItem2['default'], {
	        itemName: 'armyStatus',
	        itemValue: armyStatus.value,
	        labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceStatus', defaultMessage: '兵役狀態' }),
	        inputType: _componentsFormItem.INPUT_TYPE.RADIO,
	        onChange: armyStatus.onChange,
	        clearable: false,
	        require: armyFieldSetting.required,
	        options: militaryService.map(function (service) {
	          return {
	            label: service.text,
	            value: service.value
	          };
	        })
	      });
	    }
	  }, {
	    key: 'renderArmyDetailElems',
	    value: function renderArmyDetailElems() {
	      var _props2 = this.props;
	      var arms = _props2.arms;
	      var _props2$fields = _props2.fields;
	      var armyStatus = _props2$fields.armyStatus;
	      var armyType = _props2$fields.armyType;
	      var armyStart = _props2$fields.armyStart;
	      var armyEnd = _props2$fields.armyEnd;
	
	      var armyFieldSetting = this.props.fieldSettings['0060'];
	
	      if (armyFieldSetting.isDisplay === false || armyStatus.value === '2' || armyStatus.value === '3') {
	        return '';
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsFormItem2['default'], {
	          itemName: 'armyType',
	          itemValue: armyType.value,
	          labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceType', defaultMessage: '役別' }),
	          inputType: _componentsFormItem.INPUT_TYPE.SELECT,
	          require: armyFieldSetting.required,
	          onChange: armyType.onChange,
	          options: arms.map(function (armType) {
	            return {
	              label: armType.text,
	              value: armType.value
	            };
	          })
	        }),
	        _react2['default'].createElement(_componentsFormItem2['default'], {
	          itemName: 'armyStart',
	          itemValue: armyStart.value,
	          labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceStartTime', defaultMessage: '兵役開始時間' }),
	          inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	          allowEmpty: true,
	          require: armyFieldSetting.required,
	          onChange: armyStart.onChange
	        }),
	        _react2['default'].createElement(_componentsFormItem2['default'], {
	          itemName: 'armyEnd',
	          itemValue: armyEnd.value,
	          labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MilitaryServiceEndTime', defaultMessage: '兵役結束時間' }),
	          inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	          allowEmpty: true,
	          require: armyFieldSetting.required,
	          onChange: armyEnd.onChange
	        })
	      );
	    }
	  }, {
	    key: 'renderArmyExemptReasonElem',
	    value: function renderArmyExemptReasonElem() {
	      var exemptReason = this.props.fields.exemptReason;
	      var armyStatus = this.props.fields.armyStatus;
	      var armyFieldSetting = this.props.fieldSettings['0060'];
	
	      if (armyFieldSetting.isDisplay === false || armyStatus.value !== '2') {
	        return '';
	      }
	      return _react2['default'].createElement(_componentsFormItem2['default'], {
	        itemName: 'exemptReason',
	        itemValue: exemptReason.value,
	        labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_WaivedReason', defaultMessage: '免役原因' }),
	        inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	        require: armyFieldSetting.required,
	        onChange: exemptReason.onChange
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var genders = _props3.genders;
	      var maritalStatusOptions = _props3.maritalStatusOptions;
	      var nationality = _props3.nationality;
	      var iDTypes = _props3.iDTypes;
	      var fieldSettings = _props3.fieldSettings;
	      var onClose = _props3.onClose;
	      var submitting = _props3.submitting;
	      var error = _props3.error;
	      var _props3$fields = _props3.fields;
	      var firstName = _props3$fields.firstName;
	      var lastName = _props3$fields.lastName;
	      var englishName = _props3$fields.englishName;
	      var nation = _props3$fields.nation;
	      var gender = _props3$fields.gender;
	      var iDType = _props3$fields.iDType;
	      var iDNumber = _props3$fields.iDNumber;
	      var iDExpiryDate = _props3$fields.iDExpiryDate;
	      var iDType2 = _props3$fields.iDType2;
	      var iDNumber2 = _props3$fields.iDNumber2;
	      var iDExpiryDate2 = _props3$fields.iDExpiryDate2;
	      var iDType3 = _props3$fields.iDType3;
	      var iDNumber3 = _props3$fields.iDNumber3;
	      var iDExpiryDate3 = _props3$fields.iDExpiryDate3;
	      var entryTime = _props3$fields.entryTime;
	      var birthday = _props3$fields.birthday;
	      var maritalStatus = _props3$fields.maritalStatus;
	      var attachFile = _props3$fields.attachFile;
	      var reasons = _props3$fields.reasons;
	
	      return _react2['default'].createElement(
	        _componentsWindowBox2['default'],
	        {
	          title: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_RequestEditEmployeeData', defaultMessage: '申請修改資料' }),
	          titleBackgroundColor: '#157FCC',
	          onClose: onClose
	        },
	        _react2['default'].createElement(
	          'form',
	          {
	            className: 'form-horizontal',
	            style: { padding: 10 },
	            onSubmit: this.props.handleSubmit
	          },
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'lastName',
	            itemValue: lastName.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_LastName', defaultMessage: '姓' }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            require: true,
	            onChange: lastName.onChange,
	            errorMessage: lastName.touched && lastName.error
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'firstName',
	            itemValue: firstName.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_FirstName', defaultMessage: '名' }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            require: true,
	            onChange: firstName.onChange,
	            errorMessage: firstName.touched && firstName.error
	          }),
	          fieldSettings['0040'].isDisplay && _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'englishName',
	            itemValue: englishName.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_EnglishName', defaultMessage: '英文姓名' }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            require: fieldSettings['0040'].required,
	            onChange: englishName.onChange,
	            errorMessage: englishName.touched && englishName.error
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'nation',
	            itemValue: nation.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_Nationality', defaultMessage: '國藉' }),
	            inputType: _componentsFormItem.INPUT_TYPE.SELECT,
	            require: true,
	            onChange: nation.onChange,
	            searchable: true,
	            clearable: false,
	            errorMessage: nation.touched && nation.error,
	            options: nationality.map(function (nationOption) {
	              return {
	                label: nationOption.text,
	                value: nationOption.value
	              };
	            })
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'gender',
	            itemValue: gender.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_Gender', defaultMessage: '性別' }),
	            inputType: _componentsFormItem.INPUT_TYPE.RADIO,
	            require: true,
	            onChange: gender.onChange,
	            clearable: false,
	            errorMessage: gender.touched && gender.error,
	            options: genders.map(function (sex) {
	              return {
	                label: sex.text,
	                value: sex.value
	              };
	            })
	          }),
	          this.renderArmyStatusElem(),
	          this.renderArmyDetailElems(),
	          this.renderArmyExemptReasonElem(),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDType',
	            itemValue: iDType.value ? iDType.value.toString() : 1,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_IdentificationDocumentType', defaultMessage: '識別證件類型' }),
	            inputType: _componentsFormItem.INPUT_TYPE.SELECT,
	            require: true,
	            onChange: iDType.onChange,
	            clearable: false,
	            errorMessage: iDType.touched && iDType.error,
	            options: iDTypes.map(function (type) {
	              return {
	                label: type.text,
	                value: type.value
	              };
	            })
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDNumber',
	            itemValue: iDNumber.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_IdentificationDocumentNumber', defaultMessage: '識別證件號碼' }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            require: true,
	            errorMessage: iDNumber.touched && iDNumber.error,
	            onChange: iDNumber.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDExpiryDate',
	            itemValue: iDExpiryDate.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	            allowEmpty: true,
	            errorMessage: iDExpiryDate.touched && iDExpiryDate.error,
	            onChange: iDExpiryDate.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDType2',
	            itemValue: iDType2.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocType', defaultMessage: '識別證件類型{0}', values: { 0: '2' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            errorMessage: iDType2.touched && iDType2.error,
	            onChange: iDType2.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDNumber2',
	            itemValue: iDNumber2.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocNumber', defaultMessage: '識別證件號碼{0}', values: { 0: '2' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            errorMessage: iDNumber2.touched && iDNumber2.error,
	            onChange: iDNumber2.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDExpiryDate2',
	            itemValue: iDExpiryDate2.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '2' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	            allowEmpty: true,
	            errorMessage: iDExpiryDate2.touched && iDExpiryDate2.error,
	            onChange: iDExpiryDate2.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDType3',
	            itemValue: iDType3.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocType', defaultMessage: '識別證件類型{0}', values: { 0: '3' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            errorMessage: iDType3.touched && iDType3.error,
	            onChange: iDType3.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDNumber3',
	            itemValue: iDNumber3.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocNumber', defaultMessage: '識別證件號碼{0}', values: { 0: '3' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            errorMessage: iDNumber3.touched && iDNumber3.error,
	            onChange: iDNumber3.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'iDExpiryDate3',
	            itemValue: iDExpiryDate3.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'FD_IDDocExpiryDate', defaultMessage: '識別證件過期日{0}', values: { 0: '3' } }),
	            inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	            allowEmpty: true,
	            errorMessage: iDExpiryDate3.touched && iDExpiryDate3.error,
	            onChange: iDExpiryDate3.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'entryTime',
	            itemValue: entryTime.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_DateOfEntry', defaultMessage: '入境時間' }),
	            inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	            allowEmpty: true,
	            errorMessage: entryTime.touched && entryTime.error,
	            onChange: entryTime.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'birthday',
	            itemValue: birthday.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_DateOfBirth', defaultMessage: '生日' }),
	            inputType: _componentsFormItem.INPUT_TYPE.DATEPICKER,
	            allowEmpty: true,
	            require: true,
	            errorMessage: birthday.touched && birthday.error,
	            onChange: birthday.onChange
	          }),
	          fieldSettings['0100'].isDisplay && _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'maritalStatus',
	            itemValue: maritalStatus.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { key: '1', id: 'SH_MaterialStatus', defaultMessage: '婚姻狀態' }),
	            inputType: _componentsFormItem.INPUT_TYPE.RADIO,
	            errorMessage: maritalStatus.touched && maritalStatus.error,
	            require: fieldSettings['0100'].required,
	            onChange: maritalStatus.onChange,
	            options: maritalStatusOptions.map(function (status) {
	              return {
	                label: status.text,
	                value: status.value
	              };
	            })
	          }),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'reasons',
	            itemValue: reasons.value,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_ModifyReason', defaultMessage: '修改原因' }),
	            inputType: _componentsFormItem.INPUT_TYPE.TEXT,
	            require: true,
	            errorMessage: reasons.touched && reasons.error,
	            onChange: reasons.onChange
	          }),
	          _react2['default'].createElement(_componentsFormItem2['default'], {
	            itemName: 'attachFile',
	            itemValue: attachFile.value && attachFile.value.filename,
	            labelText: _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'FD_UploadCertificateFile', defaultMessage: '請檢附證明文件' }),
	            inputType: _componentsFormItem.INPUT_TYPE.FILE,
	            errorMessage: attachFile.touched && attachFile.error,
	            onChange: this.onAttachFileUpload.bind(this),
	            accept: '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.rtf,.pdf,.zip,.7z,.rar'
	          }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-8 col-sm-offset-4' },
	            _react2['default'].createElement(
	              'p',
	              { className: 'help-block basic__helpBlock' },
	              '* ',
	              _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_FileLimit01', defaultMessage: '格式限Microsoft Office文件、TXT純文字、壓縮檔、PDF' })
	            ),
	            _react2['default'].createElement(
	              'p',
	              { className: 'help-block basic__helpBlock' },
	              '* ',
	              this.props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' })
	            )
	          ),
	          error && _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-danger col-sm-8 col-sm-offset-4' },
	            error
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-offset-4 col-sm-8' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'pull-right' },
	                _react2['default'].createElement(
	                  'button',
	                  {
	                    style: {
	                      marginRight: 10
	                    },
	                    type: 'submit',
	                    className: 'btn btn-primary',
	                    disabled: submitting
	                  },
	                  submitting ? _react2['default'].createElement('i', { className: 'fa fa-spinner fa-spin' }) : _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_Confirm', defaultMessage: '確定' })
	                ),
	                _react2['default'].createElement(
	                  'button',
	                  { className: 'btn btn-default', onClick: onClose },
	                  _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'SH_Cancel', defaultMessage: '取消' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewRecordApplyForm;
	})(_react.Component);
	
	NewRecordApplyForm.propTypes = {
	  onClose: _propTypes2['default'].func.isRequired,
	  genders: _propTypes2['default'].array.isRequired,
	  arms: _propTypes2['default'].array.isRequired,
	  nationality: _propTypes2['default'].array.isRequired,
	  militaryService: _propTypes2['default'].array.isRequired,
	  maritalStatusOptions: _propTypes2['default'].array.isRequired,
	  iDTypes: _propTypes2['default'].array.isRequired,
	  fields: _propTypes2['default'].object.isRequired,
	  fieldSettings: _propTypes2['default'].object.isRequired,
	  handleSubmit: _propTypes2['default'].func.isRequired,
	  submitting: _propTypes2['default'].bool,
	  error: _propTypes2['default'].string,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	var fields = ['firstName', 'lastName', 'englishName', 'nation', 'gender', 'armyStatus', 'armyType', 'armyStart', 'armyEnd', 'exemptReason', 'iDType', 'iDNumber', 'iDExpiryDate', 'iDType2', 'iDNumber2', 'iDExpiryDate2', 'iDType3', 'iDNumber3', 'iDExpiryDate3', 'entryTime', 'birthday', 'maritalStatus', 'attachFile', 'reasons', 'action'];
	
	exports.fields = fields;
	var formName = 'foundation/mydata/basicinfo/NewRecordApplyForm';
	
	exports.formName = formName;
	function isEmptyString(source) {
	  if (source === null || source === undefined) {
	    return true;
	  }
	  var target = typeof source === 'number' ? source.toString() : source;
	  if (target.length === 0) {
	    return true;
	  }
	  return false;
	}
	
	function validate(value, props) {
	  var fieldSettings = props.fieldSettings;
	
	  var errors = {};
	
	  if (isEmptyString(value.lastName)) {
	    errors.lastName = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (isEmptyString(value.firstName)) {
	    errors.firstName = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0040'].required && isEmptyString(value.englishName)) {
	    errors.englishName = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (isEmptyString(value.nation)) {
	    errors.nation = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (isEmptyString(value.gender)) {
	    errors.gender = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0060'].required && isEmptyString(value.armyStatus)) {
	    errors.armyStatus = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyType)) {
	    errors.armyType = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyStart)) {
	    errors.armyStart = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyEnd)) {
	    errors.armyEnd = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0060'].required && value.armyStatus === '2' && isEmptyString(value.exemptReason)) {
	    errors.exemptReason = props.intl.formatMessage(messages.isRequired);
	  }
	  if (isEmptyString(value.iDType)) {
	    errors.iDType = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (isEmptyString(value.iDType) === false && /1|3/.test(value.iDType) && (0, _containersAppScreensFoundationUtilsVerify.isInvalidID)(value.iDNumber, String(value.iDType) === '3')) {
	    errors.iDNumber = props.intl.formatMessage(messages.formatError);
	  }
	
	  if (isEmptyString(value.birthday)) {
	    errors.birthday = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (fieldSettings['0100'].required && isEmptyString(value.maritalStatus)) {
	    errors.maritalStatus = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (isEmptyString(value.reasons)) {
	    errors.reasons = props.intl.formatMessage(messages.isRequired);
	  }
	
	  if (value.attachFile && value.attachFile.size === 0) {
	    errors.attachFile = props.intl.formatMessage(messages.emptyData);
	  }
	
	  if (value.attachFile && value.attachFile.size > 300000) {
	    errors.attachFile = props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' });
	  }
	
	  return errors;
	}
	
	NewRecordApplyForm = (0, _reduxForm.reduxForm)({
	  form: formName,
	  fields: fields,
	  validate: validate
	})(NewRecordApplyForm);
	
	exports['default'] = (0, _reactIntl.injectIntl)(NewRecordApplyForm);

/***/ },

/***/ 1414:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1415);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(818);
	
	// import crossImg from 'components/cross.svg';
	
	var WindowBox = (function (_Component) {
	  _inherits(WindowBox, _Component);
	
	  function WindowBox() {
	    _classCallCheck(this, WindowBox);
	
	    _get(Object.getPrototypeOf(WindowBox.prototype), 'constructor', this).call(this);
	  }
	
	  _createClass(WindowBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.hasVerticalScroll();
	      // this.toggleBodyVisible('hidden');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.toggleBodyVisible('visible');
	    }
	
	    // scrollbar hidden when WindowBox show
	  }, {
	    key: 'toggleBodyVisible',
	    value: function toggleBodyVisible(param) {
	      var getBody = document.getElementsByTagName('body')[0];
	      var getNavbar = document.getElementById('navbar');
	      var getWinBoxs = document.getElementsByClassName('new-window-container');
	      if (getWinBoxs.length === 1) {
	        getBody.style.overflow = param;
	      }
	      if (param === 'hidden') {
	        getBody.style.paddingRight = '16px';
	        getNavbar.style.paddingRight = '16px';
	      } else {
	        getBody.style.paddingRight = '0px';
	        getNavbar.style.paddingRight = '0px';
	      }
	    }
	  }, {
	    key: 'hasVerticalScroll',
	    value: function hasVerticalScroll() {
	      if (window.innerHeight) {
	        if (document.body.offsetHeight > innerHeight) {
	          this.toggleBodyVisible('hidden');
	          return;
	        }
	      } else {
	        if (document.documentElement.scrollHeight > document.documentElement.offsetHeight || document.body.scrollHeight > document.body.offsetHeight) {
	          this.toggleBodyVisible('hidden');
	          return;
	        }
	      }
	      return;
	    }
	  }, {
	    key: 'renderLayerPostion',
	    value: function renderLayerPostion(layer) {
	      // if input value isn't number (false), return;
	      if (/[^0-9]/.test(layer)) {
	        return {};
	      }
	      // basicMargin + ((headHeight + spacing) * layer)
	      var top = 60 + (40 + 5) * layer;
	      // spacing * layer
	      var left = 15 * layer;
	      return {
	        marginTop: top + 'px',
	        left: 'calc(50% + ' + left + 'px)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var // set WindowBox title
	      onClose = _props.onClose;
	      var // set WindowBox close function
	      onConfirm = _props.onConfirm;
	      var // set WindowBox 確認 button function
	      onCancel = _props.onCancel;
	      var // set WindowBox 取消 button function
	      width = _props.width;
	      var // set WindowBox width
	      height = _props.height;
	      var // set WindowBox height
	      layer = _props.layer;
	      var center = _props.center;
	      var newcss = _props.newcss;
	      var newWin = _props.newWin;
	      var titleBackgroundColor = _props.titleBackgroundColor;
	      var containerStyle = _props.containerStyle;
	      var disabled = _props.disabled;
	      var confirmText = _props.confirmText;
	      var confirmDisabled = _props.confirmDisabled;
	
	      var layerNum = parseInt(layer, 10);
	      var modalStyle = null;
	      if (layerNum > 0) {
	        modalStyle = {
	          backgroundColor: 'transparent'
	        };
	      }
	      var boxStyle = {
	        width: width ? width : 600,
	        height: height ? height : 'auto'
	      };
	      boxStyle = Object.assign(boxStyle, this.renderLayerPostion(layerNum));
	
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])('new-window-container', { 'is-center': center, 'new': newcss, newWin: newWin }), style: modalStyle },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'new-window',
	            style: boxStyle
	          },
	          _react2['default'].createElement(
	            'div',
	            {
	              className: 'new-window-title',
	              style: {
	                backgroundColor: titleBackgroundColor ? titleBackgroundColor : '#131c39'
	              }
	            },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2['default'].createElement(
	              'button',
	              { className: 'btn new-window-title-button', onClick: onClose, disabled: disabled },
	              _react2['default'].createElement(
	                'span',
	                { className: 'fa-stack fa-lg', style: { width: '18px', height: '18px', 'lineHeight': '18px' } },
	                _react2['default'].createElement('i', { className: 'fa fa-circle fa-stack-1x fa-inverse py_window_inverse', style: { color: titleBackgroundColor ? titleBackgroundColor : '#131c39', fontSize: '1.2em' } }),
	                _react2['default'].createElement('i', { className: 'fa fa-circle fa-stack-1x', style: { color: 'rgba(255, 255, 255, 0.5)' } }),
	                _react2['default'].createElement('i', { className: 'fa fa-times fa-stack-1x', style: { color: titleBackgroundColor ? titleBackgroundColor : '#131c39', fontSize: '0.59em' } })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'new-window-body clearfix', style: containerStyle },
	            this.props.children
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'new-window-actions clearfix', style: { borderTop: '1px solid #eee', padding: '6px 10px', textAlign: 'right' } },
	            onConfirm && _react2['default'].createElement(
	              'button',
	              { type: 'button', className: 'btn btn-default', onClick: onConfirm, disabled: disabled || confirmDisabled },
	              confirmText ? confirmText : _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                id: 'SH_Confirm',
	                defaultMessage: '確定'
	              })
	            ),
	            onCancel && _react2['default'].createElement(
	              'button',
	              { type: 'button', className: 'btn btn-default', onClick: onCancel, disabled: disabled },
	              _react2['default'].createElement(_reactIntl.FormattedMessage, {
	                id: 'SH_Cancel',
	                defaultMessage: '取消'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WindowBox;
	})(_react.Component);
	
	exports['default'] = WindowBox;
	
	WindowBox.propTypes = {
	  title: _propTypes2['default'].any,
	  children: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
	  onClose: _propTypes2['default'].func.isRequired,
	  onConfirm: _propTypes2['default'].func,
	  onCancel: _propTypes2['default'].func,
	  containerStyle: _propTypes2['default'].func,
	  width: _propTypes2['default'].number,
	  height: _propTypes2['default'].number,
	  layer: _propTypes2['default'].string,
	  center: _propTypes2['default'].bool,
	  newcss: _propTypes2['default'].bool,
	  newWin: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  confirmDisabled: _propTypes2['default'].bool,
	  confirmText: _propTypes2['default'].string,
	  titleBackgroundColor: _propTypes2['default'].string
	};
	
	WindowBox.defaultProps = {
	  title: '',
	  layer: '0',
	  center: false
	};
	module.exports = exports['default'];
	/* <img src={crossImg} width="20px" height="20px"/> */

/***/ },

/***/ 1415:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1416);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./WindowBox.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./WindowBox.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1416:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".new-window-container{position:fixed;top:0;left:0;bottom:0;right:0;z-index:11;-ms-overflow-x:hidden;overflow-x:hidden;-ms-overflow-y:auto;overflow-y:auto;background-color:rgba(0,0,0,.5)}.new-window{position:absolute;top:0;left:50%;width:600px;padding:0;margin:60px 0 170px;background-color:#fff;border-radius:5px;transform:translate(-50%, 0);box-shadow:0 5px 15px rgba(0,0,0,.5)}.new-window .btn-bar{text-align:right;padding-right:5px}.hr_nomargin{border-top:1px solid #ccc;margin:0 0 6px}.new-window-container.is-center .new-window{top:50%!important;margin-top:0!important;transform:translate(-50%, -50%)!important}.new-window-title{position:relative;background-color:#131c39;color:#fff;border-radius:5px 5px 0 0}.new-window-title h1{margin:0;line-height:19px;font-size:18px;padding:9px 20px;text-align:left;font-size:1rem}.new-window-title-button{position:absolute;background-color:transparent;top:50%;right:0;transform:translateY(-50%);margin:0}.new-window-body{margin:5px 15px}.new .new-window-body,.newWin .new-window-body{margin:0}.new .new-window-body form>div:first-child{margin:30px 25px}.new-window-actions{margin-top:10px}.new-window-actions button{margin-left:5px}.new-window-actions .btn-primary{background-color:#131c39;border-color:#121931}.new-window-actions .btn-primary:hover{background-color:#081850;border-color:#121931}", ""]);
	
	// exports


/***/ },

/***/ 1417:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(996);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _componentsDatePickInputer = __webpack_require__(983);
	
	var _componentsDatePickInputer2 = _interopRequireDefault(_componentsDatePickInputer);
	
	var _classnames = __webpack_require__(875);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1418);
	
	var INPUT_TYPE = {
	  TEXT: 'TEXT',
	  SELECT: 'SELECT',
	  RADIO: 'RADIO',
	  DATEPICKER: 'DATEPICKER',
	  CUSTOM: 'CUSTOM',
	  FILE: 'FILE'
	};
	
	exports.INPUT_TYPE = INPUT_TYPE;
	
	var FormItem = (function (_Component) {
	  _inherits(FormItem, _Component);
	
	  function FormItem() {
	    _classCallCheck(this, FormItem);
	
	    _get(Object.getPrototypeOf(FormItem.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(FormItem, [{
	    key: 'renderTextBox',
	    value: function renderTextBox() {
	      var _props = this.props;
	      var itemName = _props.itemName;
	      var itemValue = _props.itemValue;
	      var onChange = _props.onChange;
	
	      return _react2['default'].createElement('input', {
	        className: 'form-control',
	        id: itemName,
	        value: itemValue,
	        type: 'text',
	        onChange: onChange
	      });
	    }
	  }, {
	    key: 'renderRadios',
	    value: function renderRadios() {
	      var _props2 = this.props;
	      var itemName = _props2.itemName;
	      var itemValue = _props2.itemValue;
	      var options = _props2.options;
	      var onChange = _props2.onChange;
	
	      return options.map(function (option) {
	        var itemKey = itemName + '_' + option.value;
	        var checkedValue = option.value;
	        return _react2['default'].createElement(
	          'label',
	          {
	            htmlFor: itemKey,
	            className: 'radio-inline',
	            key: itemKey
	          },
	          _react2['default'].createElement('input', {
	            id: itemKey,
	            name: itemName,
	            value: option.value,
	            type: 'radio',
	            onChange: function () {
	              onChange(checkedValue);
	            },
	            checked: checkedValue === itemValue
	          }),
	          option.label
	        );
	      });
	    }
	  }, {
	    key: 'renderSelect',
	    value: function renderSelect() {
	      var _props3 = this.props;
	      var itemValue = _props3.itemValue;
	      var itemName = _props3.itemName;
	      var options = _props3.options;
	      var onChange = _props3.onChange;
	      var _props3$searchable = _props3.searchable;
	      var searchable = _props3$searchable === undefined ? false : _props3$searchable;
	      var _props3$clearable = _props3.clearable;
	      var clearable = _props3$clearable === undefined ? false : _props3$clearable;
	
	      return _react2['default'].createElement(_reactSelect2['default'], {
	        name: itemName,
	        options: options,
	        value: itemValue,
	        searchable: searchable,
	        clearable: clearable,
	        placeholder: '',
	        onChange: onChange
	      });
	    }
	  }, {
	    key: 'renderDatePicker',
	    value: function renderDatePicker() {
	      var _props4 = this.props;
	      var itemValue = _props4.itemValue;
	      var onChange = _props4.onChange;
	      var allowEmpty = _props4.allowEmpty;
	      var minDate = _props4.minDate;
	      var disabled = _props4.disabled;
	
	      return _react2['default'].createElement(_componentsDatePickInputer2['default'], {
	        initialMonth: itemValue,
	        allowEmpty: allowEmpty,
	        handleDayClick: function (event, value) {
	          onChange(value);
	        },
	        minDate: minDate,
	        disabled: disabled
	      });
	    }
	  }, {
	    key: 'renderFileInputer',
	    value: function renderFileInputer() {
	      var _props5 = this.props;
	      var itemName = _props5.itemName;
	      var itemValue = _props5.itemValue;
	      var onChange = _props5.onChange;
	      var accept = _props5.accept;
	
	      return _react2['default'].createElement('input', {
	        className: 'form-control',
	        style: { color: '#999', height: 'auto', padding: '5px' },
	        id: itemName,
	        value: itemValue,
	        type: 'file',
	        onChange: onChange,
	        accept: accept
	      });
	    }
	  }, {
	    key: 'renderFormItem',
	    value: function renderFormItem() {
	      var inputType = this.props.inputType;
	      switch (inputType) {
	        case INPUT_TYPE.TEXT:
	          return this.renderTextBox();
	        case INPUT_TYPE.RADIO:
	          return this.renderRadios();
	        case INPUT_TYPE.SELECT:
	          return this.renderSelect();
	        case INPUT_TYPE.DATEPICKER:
	          return this.renderDatePicker();
	        case INPUT_TYPE.CUSTOM:
	          return this.props.children;
	        case INPUT_TYPE.FILE:
	          return this.renderFileInputer();
	        default:
	          return this.renderTextBox();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props;
	      var itemName = _props6.itemName;
	      var labelText = _props6.labelText;
	      var require = _props6.require;
	      var errorMessage = _props6.errorMessage;
	      var style = _props6.style;
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: (0, _classnames2['default'])({
	            'formItem': true,
	            'form-group': true,
	            require: require
	          }),
	          style: style
	        },
	        _react2['default'].createElement(
	          'label',
	          { htmlFor: itemName, className: 'col-sm-4 control-label' },
	          labelText,
	          labelText ? ' : ' : ''
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-8' },
	          this.renderFormItem(),
	          _react2['default'].createElement(
	            'div',
	            { className: 'text-danger', style: { paddingLeft: 10 } },
	            errorMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormItem;
	})(_react.Component);
	
	exports['default'] = FormItem;
	
	FormItem.propTypes = {
	  itemName: _propTypes2['default'].string.isRequired,
	  labelText: _propTypes2['default'].object.isRequired,
	  style: _propTypes2['default'].object,
	  itemValue: _propTypes2['default'].string.isRequired,
	  inputType: _propTypes2['default'].oneOf(Object.values(INPUT_TYPE)),
	  options: _propTypes2['default'].array,
	  children: _propTypes2['default'].array,
	  onChange: _propTypes2['default'].func,
	  searchable: _propTypes2['default'].bool, // Select 是否允許搜尋
	  clearable: _propTypes2['default'].bool, // Select 是否允許清除
	  require: _propTypes2['default'].bool, // 是否顯示必填*
	  allowEmpty: _propTypes2['default'].bool, // DatePicker 是否允許空值
	  accept: _propTypes2['default'].string, // FILE 允許的副檔名
	  minDate: _propTypes2['default'].string,
	  errorMessage: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool
	};

/***/ },

/***/ 1418:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1419);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(843)(content, {"attrs":{"nonce":"xe-random"}});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 1419:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(842)();
	// imports
	
	
	// module
	exports.push([module.id, ".mydata .form-group.require>label:before{content:'*';color:red}.Select-menu-outer{z-index:3}", ""]);
	
	// exports


/***/ },

/***/ 1420:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isInvalidID = isInvalidID;
	
	function isInvalidID(idStr, resident) {
	  if (idStr === undefined || idStr === null) {
	    return true;
	  }
	
	  var identityNumberRegex = /^[A-Z][1|2]\d{8}$/;
	  var oldResidentNumberRegex = /^[A-Z][A|B|C|D]\d{8}$/;
	  var newResidentNumberRegex = /^[A-Z][8|9]\d{8}$/;
	  var isNewResidentRule = false;
	
	  if (resident) {
	    if (newResidentNumberRegex.test(idStr)) {
	      isNewResidentRule = true;
	    } else if (!oldResidentNumberRegex.test(idStr)) {
	      return true;
	    }
	  }
	  if (!resident && !identityNumberRegex.test(idStr)) return true;
	
	  // 依照字母的編號排列，存入陣列備用。
	  var letters = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
	  // 儲存各個乘數
	  var multiply = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1);
	  var nums = new Array(3);
	  // 取出第一個字元
	  var firstChar = idStr.charAt(0).toUpperCase();
	  var firstNum = undefined;
	  var total = 0;
	  // 找出第一個字母對應的數字，並轉換成兩位數數字。
	  for (var i = 0; i < 26; i++) {
	    if (firstChar === letters[i]) {
	      firstNum = i + 10;
	      nums[0] = Math.floor(firstNum / 10);
	      nums[1] = firstNum - nums[0] * 10;
	      break;
	    }
	  }
	  if (resident) {
	    var secondChar = idStr.charAt(1).toUpperCase();
	    var secondNum = undefined;
	    if (isNewResidentRule) {
	      nums[2] = idStr.charAt(1);
	    } else {
	      // 計算居留證第二英文個位數
	      for (var i = 0; i < 4; i++) {
	        if (secondChar === letters[i]) {
	          secondNum = i + 10;
	          var tenDigit = Math.floor(secondNum / 10);
	          nums[2] = secondNum - tenDigit * 10;
	        }
	      }
	    }
	    // 計算居留證總和
	    for (var i = 0; i < multiply.length; i++) {
	      if (i < 3) {
	        total += nums[i] * multiply[i];
	      } else {
	        total += parseInt(idStr.charAt(i - 1), 10) * multiply[i];
	      }
	    }
	  } else {
	    // 身分證總和
	    for (var i = 0; i < multiply.length; i++) {
	      if (i < 2) {
	        total += nums[i] * multiply[i];
	      } else {
	        total += parseInt(idStr.charAt(i - 1), 10) * multiply[i];
	      }
	    }
	  }
	  // 整除十等於0 為正確身分證/居留證
	  if (total % 10 === 0) {
	    return false;
	  }
	  return true;
	}

/***/ }

});


/** WEBPACK FOOTER **
 ** 4.chunk.63a2d387592292ad3ca1.js
 **/